import { axiosInstance } from "../../../config/api/Axios";

export const getTagsByFilterApi = (params) =>
    axiosInstance.get("/utils/tags", {
        params,
    });
